import React from 'react';
import { Common } from '@stockbit/ui';
import { MessageCount } from './styled';
import { DATA_CY_NAME_MESSAGE_ICON_INBOX_CHAT } from './__tests__/constant';

const { Iconmoon, IconWrapper } = Common;

export interface MessageIconProps {
  count: number;
}

const MessageIcon = ({ count, ...props }: MessageIconProps) => (
  <IconWrapper
    {...props}
    size="40px"
    data-cy={DATA_CY_NAME_MESSAGE_ICON_INBOX_CHAT}
  >
    <Iconmoon size="30px" className="icon-panel_chat" />
    {count > 0 && <MessageCount>{count > 99 ? '99+' : count}</MessageCount>}
  </IconWrapper>
);

export default MessageIcon;
